import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { SecondaryButton } from '../../../components';
import css from './SectionReadyToSell.module.css';

const benefits = [
  'List items in minutes with guided steps and photo tips.',
  'Reach verified buyers and the MM community instantly.',
  'Get secure payments and shipping support built in.',
  'Track every order from sale to delivery.',
];

function SectionReadyToSell() {
  const history = useHistory();

  return (
    <section className={css.readyToSellSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          <span>Ready to Sell?</span>
          <h2>Turn Your Mahjong Gear Into Cash</h2>
          <p>Everything you need to post, ship, and get paid without the hassle.</p>
        </div>
        <ul className={css.benefitsList}>
          {benefits.map(item => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        <SecondaryButton className={css.sellButton} onClick={() => history.push('/l/new')}>
          Sell Now
        </SecondaryButton>
      </div>
    </section>
  );
}

export default SectionReadyToSell;
